import React from "react";
import { Package, Paintbrush, Tag, HeadphonesIcon, ArrowRight } from "lucide-react";

const BuyMachine = () => {
  const features = [
    {
      icon: Package,
      title: "Kjøp direkte fra oss",
      description: "Vi er norsk leverandør med lokalt lager",
    },
    {
      icon: Paintbrush,
      title: "Tilpasset design",
      description: "Få din logo og branding på stasjonen",
    },
    {
      icon: Tag,
      title: "Konkurransedyktige priser",
      description: "Direkte fra importør – ingen mellomledd",
    },
    {
      icon: HeadphonesIcon,
      title: "Support inkludert",
      description: "Full opplæring og teknisk support",
    },
  ];

  return (
    <section
      id="buy"
      className="py-24 md:py-32 bg-[#0A0A0A]"
      data-testid="buy-machine-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Product Image */}
          <div className="relative order-2 lg:order-1">
            <div className="absolute inset-0 bg-[#FFD84D]/10 blur-3xl rounded-full" />
            <img
              src="https://static.prod-images.emergentagent.com/jobs/34039477-a207-4dc8-98b5-a0f0d25d9137/images/9a1752ee278ab3c3e60e4bdeadc10ab1f54d5a94625152cfce8191291a4e592b.png"
              alt="B-Labs Powerbank Stasjon"
              className="relative z-10 w-full max-w-lg mx-auto"
              data-testid="buy-machine-image"
            />
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <span className="text-xs tracking-[0.2em] uppercase font-bold text-[#FFD84D] mb-4 block">
              For kjøpere
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-white mb-6 font-['Outfit']">
              Kjøp en maskin
            </h2>
            <p className="text-lg text-[#A1A1AA] mb-10 leading-relaxed">
              Vil du eie din egen powerbank-stasjon? Vi er en norsk leverandør med
              alt du trenger for å komme i gang.
            </p>

            {/* Features Grid */}
            <div className="grid sm:grid-cols-2 gap-6 mb-10">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="flex items-start gap-4"
                  data-testid={`buy-feature-${index + 1}`}
                >
                  <div className="w-10 h-10 bg-[#FFD84D]/10 rounded-lg flex items-center justify-center shrink-0">
                    <feature.icon className="w-5 h-5 text-[#FFD84D]" />
                  </div>
                  <div>
                    <h4 className="text-white font-medium mb-1">{feature.title}</h4>
                    <p className="text-sm text-[#A1A1AA]">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA */}
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
              }}
              className="btn-primary inline-flex items-center gap-2 group"
              data-testid="buy-machine-cta"
            >
              Be om tilbud
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BuyMachine;
